// // Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails

// // import "jquery_ujs";
import Rails from "@rails/ujs";
require("turbolinks").start();
require("@rails/activestorage").start();
require("jquery");
require("fix/ujs_disable_with_safari");

global.Rails = Rails;

import Mascaras from "mascaras";

import MicroModal from "micromodal";

import 'init_stimulus'

// turbolinks load
document.addEventListener('turbolinks:load', function (event) {
  for (let input of document.querySelectorAll('input[type=submit][data-turbolinks-progressbar=true]')) {
    input.addEventListener('click', function (evt) {
      Turbolinks.controller.adapter.progressBar.setValue(0);
      Turbolinks.controller.adapter.showProgressBarAfterDelay();
    });
  }

  global.Mascaras = new Mascaras()
  global.Mascaras.start()

  MicroModal.init()
});
